export function saveHistory(query) {
  const history = JSON.parse(localStorage.getItem("query_history") || "[]");
  history.unshift({ query, time: new Date().toISOString() });
  localStorage.setItem("query_history", JSON.stringify(history));
}

export function getHistory() {
  return JSON.parse(localStorage.getItem("query_history") || "[]");
}

export function clearHistory() {
  localStorage.removeItem("query_history");
}
